import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FaGlobeAmericas, FaGlobeAsia } from "react-icons/fa"; // Importing icons

function LanguageSelector() {
  const { i18n } = useTranslation();
  const [currentLang, setCurrentLang] = useState("en"); // State to track the current language

  // Load the saved language from local storage on mount
  useEffect(() => {
    const savedLanguage = localStorage.getItem("i18nextLng") || "en"; // Default to English
    i18n.changeLanguage(savedLanguage);
    setCurrentLang(savedLanguage);
  }, [i18n]);

  const handleLanguageChange = (lang) => {
    i18n.changeLanguage(lang);
    localStorage.setItem("i18nextLng", lang); // Save the selected language to local storage
    setCurrentLang(lang); // Update the current language state
  };

  return (
    <div className="language-selector flex items-center ">
      {/* Show currently selected language */}
      <span
        onClick={() =>
          handleLanguageChange(currentLang === "en" ? "zh-TW" : "en")
        }
        className="cursor-pointer flex items-center "
        title={currentLang === "en" ? "Switch to 繁體" : "Switch to English"}
      >
        {currentLang === "en" ? (
          <>
            <FaGlobeAmericas size={13} className="mr-1" />
            中文
          </>
        ) : (
          <>
            <FaGlobeAsia size={13} className="mr-1" />
            ENG
          </>
        )}
      </span>
    </div>
  );
}

export default LanguageSelector;
